import api from '@/lib/axios';

export const get = () => api.get('/system/global-info');
export const update = (data: Record<string, unknown>) => api.put('/system/global-info', data);
